import React from 'react';
import { Table, Checkbox, BodyText } from '@gaiads/telia-react-component-library';
import i18n from 'i18next';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LocaleResponse, SalesChannel } from '@cdaas/api-clients/dist/product-service-openapi';

import LanguageList from '../../../shared/ListUtil/LanguageList';

interface SalesChannelListItemProps {
  children?: JSX.Element | JSX.Element[];
  locales: LocaleResponse[];
  salesChannel: SalesChannel;
  selected: boolean;
  onSalesChannelChecked: (salesChannel: SalesChannel) => void;
}

export const SalesChannelInfo = ({
  productSalesChannelIds,
  allSalesChannels,
}: {
  productSalesChannelIds: number[] | undefined;
  allSalesChannels: SalesChannel[];
}) => {
  if (!Array.isArray(productSalesChannelIds) || allSalesChannels.length === 0) {
    return null;
  }

  const productSalesChannelsTexts = productSalesChannelIds.map((salesChannelId: number) => {
    return allSalesChannels.find((salesChannel: SalesChannel) => salesChannel.id === salesChannelId)?.name;
  });

  const [first] = productSalesChannelsTexts;

  if (Array.isArray(productSalesChannelsTexts) && productSalesChannelsTexts.length > 1) {
    const leftCount = productSalesChannelsTexts.length - 1;
    return <>{i18n.t('productsscreen:productsTable.salesChannelAndMore', { salesChannel: first, leftCount: leftCount })}</>;
  }
  return <>{first}</>;
};

export default function SalesChannelListItem(props: SalesChannelListItemProps) {
  const { children, selected, locales, salesChannel, onSalesChannelChecked } = props;

  const { id, name, locale_ids } = salesChannel;

  const { t } = useTranslation('saleschannelsscreen');

  const history = useHistory();

  return (
    <>
      <Table.Row className="telia-react-table_row__master">
        <Table.Cell type="checkbox">
          <Checkbox
            checked={selected}
            onChange={() => onSalesChannelChecked(salesChannel)}
            onClick={event => event.stopPropagation()}
            title={t('select')}
            data-testid={`row-select-${salesChannel.id}`}
          />
        </Table.Cell>
        <Table.Cell onClick={() => history.push(`/saleschannel/${salesChannel.uuid}/bundles`)}>
          <BodyText>{name}</BodyText>
        </Table.Cell>
        <Table.Cell>
          <BodyText>{id}</BodyText>
        </Table.Cell>
        <Table.Cell>
          <LanguageList languages={locale_ids} locales={locales} />
        </Table.Cell>
      </Table.Row>
      {children}
    </>
  );
}
